import * as React from 'react';
import './TabTitle.scss';

interface ITabTitleProps {
  title: string;
  count?: number;
  showCount?: boolean;
  disabled?: boolean;
}

export function TabTitle(props: ITabTitleProps) {
  const disabled = props.disabled != null ? props.disabled : false;
  return (
    <button  className="rp-tabtitle">
      <span className={'rp-tabtitle--title' + (disabled ? ' disabled' : '')}>
        {props.title}
      </span>
      {props.showCount ? (
        <div className={'rp-tabtitle--count' + (disabled ? ' disabled' : '')}>
          {props.count}
        </div>
      ) : null}
    </button>
  );
}
